// extracted by mini-css-extract-plugin
module.exports = {"MarketplaceBanner":"MarketplaceBanner_MarketplaceBanner__ucd9G","Card":"MarketplaceBanner_Card__3zMyS","Media":"MarketplaceBanner_Media__1IeVU"};